var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Downshift from 'downshift';
import React from 'react';
import { FloatingMenu } from '../../forms/FloatingMenu';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { TypeaheadInput } from './TypeaheadInput';
const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, ' ').trim();
const defaultFilterItems = (inputValue, items, getLabelForItem, showEmptyList = false) => {
    if (showEmptyList || !inputValue) {
        return items;
    }
    const lowerCaseInput = inputValue.toLowerCase();
    return items.filter((item) => {
        return getLabelForItem(item)
            .toLowerCase()
            .includes(dedupeAndTrimWhitespace(lowerCaseInput));
    });
};
const Styles = labelStyles('Typeahead', {
    root: () => [
        {
            position: 'relative',
        },
    ],
});
export class Typeahead extends React.Component {
    constructor() {
        super(...arguments);
        this.itemToString = (item) => {
            return item ? this.props.getLabelForItem(item) : '';
        };
        this.stateReducer = (state, changes) => {
            if (this.props.keepInputValueOnBlur &&
                (changes.type === Downshift.stateChangeTypes.blurInput ||
                    changes.type === Downshift.stateChangeTypes.mouseUp)) {
                return Object.assign(Object.assign({}, changes), { inputValue: state.inputValue });
            }
            return changes;
        };
    }
    render() {
        const { props } = this;
        return (isolateComponent(Downshift, { id: props.id, initialSelectedItem: props.selectedItem || props.initialSelectedItem, inputId: props.inputId, inputValue: props.inputValue, itemToString: this.itemToString, labelId: props.labelId, onChange: props.onChange, onInputValueChange: props.onInputValueChange, selectedItem: props.selectedItem, stateReducer: this.stateReducer }, ({ clearSelection, getInputProps, getItemProps, getMenuProps, getRootProps, highlightedIndex, inputId, inputValue, isOpen, openMenu, selectedItem, }) => {
            if (props.setClearSelection) {
                props.setClearSelection(clearSelection);
            }
            const ariaLabelledBy = props.labelId || null;
            const _a = getRootProps({
                'aria-labelledby': ariaLabelledBy,
                refKey: 'innerRef',
            }), { innerRef } = _a, rootProps = __rest(_a, ["innerRef"]);
            const filteredItems = props.filterItems(inputValue, props.items, props.getLabelForItem, props.showEmptyList || false);
            const showMenu = isOpen && filteredItems.length > 0;
            const isErrored = (props.showErrorOnNoResults &&
                inputValue &&
                filteredItems.length === 0) ||
                props.isErrored;
            return (isolateComponent("div", Object.assign({}, rootProps, { css: Styles.root(), ref: innerRef }),
                isolateComponent(TypeaheadInput, { ariaLabel: props.ariaLabel, ariaLabelledBy: ariaLabelledBy, autoComplete: props.autoComplete, clearSelection: clearSelection, disabledText: props.disabledText, getInputProps: getInputProps, getLabelForItem: props.getLabelForItem, iconEndName: props.iconEndName, inputValue: inputValue, isBusy: props.isBusy, isDisabled: props.isDisabled, isErrored: !!isErrored, onFocus: props.openOnFocus ? openMenu : undefined, placeholder: props.placeholder, renderIcon: props.renderIcon, selectedItem: selectedItem, size: props.size }),
                showMenu &&
                    props.renderFloatingMenu({
                        ariaLabel: props.menuAriaLabel,
                        getItemProps,
                        getKeyForItem: props.getKeyForItem,
                        getLabelForItem: props.getLabelForItem,
                        getMenuProps,
                        highlightedIndex,
                        items: filteredItems,
                        renderIcon: props.renderIcon,
                    })));
        }));
    }
}
Typeahead.defaultProps = {
    filterItems: defaultFilterItems,
    isDisabled: false,
    openOnFocus: false,
    renderFloatingMenu: (props) => (isolateComponent(FloatingMenu, Object.assign({}, props))),
    showEmptyList: false,
    showErrorOnNoResults: false,
};
export default Typeahead;
//# sourceMappingURL=Typeahead.js.map
// @zapier/design-system@6.14.1 (10126c41d)
